import { transport } from 'config/transport';

export function callApiGetReportDuThuForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/duthuchi/duthu`, { params: { academicYear } });
}
